import { Burger, Flex, useMantineTheme } from '@mantine/core'
import { DateTime } from 'luxon'

import type { AppShellCollapsedProps } from '@/types/appShell.types'

import { AccountMenu } from '@/layouts/AuthenticatedLayout/components/AccountMenu/AccountMenu'
import { Support } from '@/layouts/AuthenticatedLayout/components/Support/Support'
import { SwitchRole } from '@/layouts/AuthenticatedLayout/components/SwitchRole/SwitchRole'

import { useUserStore } from '@/store/user.store'

import { Text } from '@/components/Text/Text'

import classes from './Topbar.module.css'

export function Topbar({ opened, toggle }: AppShellCollapsedProps) {
  const user = useUserStore.use.user()

  const theme = useMantineTheme()

  const now = DateTime.now()

  return (
    <Flex className={classes.topbar}>
      <Text visibleFrom="sm">{now.toFormat('cccc, LLLL d, yyyy')}</Text>

      <Burger
        color={theme.other.colors.black}
        hiddenFrom="sm"
        onClick={toggle}
        opened={opened}
        size="sm"
      />

      <Flex>
        <Support />

        {user?.roles && user?.roles?.length > 1 && <SwitchRole user={user} />}

        <AccountMenu />
      </Flex>
    </Flex>
  )
}
